<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Assistance technique</div>
</div>
@if (landLine && [null, ''].indexOf(customer.siret) == -1 && environment.data.brand == 'coriolis') {
    <div class="col-12 w-100 text-center cta_container mt-3">
        Consultez et gérez l'état de vos installations et raccordements en temps réel.
        <br/>
        <button type="button" class="cta_btn column" (click)="goToSupervisionPlatform()">Supervision des installations
        </button>
        <br/><br/>
        Ouvrez un ticket pour signaler tout problème technique ou incident rencontré.
        <br/>
        <button type="button" class="cta_btn column" (click)="goToIncidentPlatform()">Signaler un incident</button>
        <br/><br/>
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
    </div>
}
@if (line || (landLine && [null, ''].indexOf(customer.siret) !== -1)) {
    <div class="col-12 w-100">
        <p>
            <br/>
            Vous pouvez toujours consulter nos <a href="{{ assistanceUrl }}" class="blue-color" target="_blank">FAQ</a>.
            <strong style="font-weight: 900;">Pour nous contacter, RDV sur le chat disponible ci-dessous</strong>
            dans l'Appli Prixtel et sur notre site (si vous êtes connecté à votre compte).<br/>
        </p>
        <div class="col-12 w-100 text-center cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="button" class="cta_btn column" (click)="confirmation()">J'y vais</button>
        </div>
    </div>
}
